import { CheckCircle2, XCircle } from "lucide-react";

const genericItems = [
  "Same plants everywhere",
  "USDA zone only",
  "Decorative focus",
  "Generic recommendations",
];

const frogItems = [
  "Regionally validated recommendations",
  "EPA ecoregion matching",
  "Native-range verification",
  "Pollinator and wildlife support",
  "Real regional reference sources",
];

const whyItems = [
  "Better planting success",
  "More butterflies and birds",
  "Less guesswork",
  "More trustworthy plans",
];

const EcosystemTrustSection = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/30 border-y border-border/30">
      <div className="container max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Built Around Your Real Ecosystem — Not Generic Plant Lists
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto leading-relaxed text-sm sm:text-base">
            Most garden apps recommend plants that merely survive in your USDA
            zone. Frog Knows Natives validates recommendations using regional
            native plant references, ecoregions, sunlight, soil, moisture, and
            wildlife value.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {/* Column 1 — Generic */}
          <div className="rounded-xl border border-border/40 bg-card p-6">
            <h3 className="font-display font-semibold text-sm text-muted-foreground uppercase tracking-wide mb-4">
              Generic Garden Apps
            </h3>
            <ul className="space-y-3">
              {genericItems.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-2 text-sm text-muted-foreground"
                >
                  <XCircle className="h-4 w-4 text-muted-foreground/60 mt-0.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2 — Frog Knows Natives */}
          <div className="rounded-xl border-2 border-primary/20 bg-primary/[0.03] p-6 relative">
            <span className="absolute -top-3 left-6 inline-block bg-primary text-primary-foreground text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded">
              This Tool
            </span>
            <h3 className="font-display font-semibold text-sm text-foreground uppercase tracking-wide mb-4">
              Frog Knows Natives
            </h3>
            <ul className="space-y-3">
              {frogItems.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-2 text-sm text-foreground"
                >
                  <CheckCircle2 className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 — Why It Matters */}
          <div className="rounded-xl border border-border/40 bg-card p-6">
            <h3 className="font-display font-semibold text-sm text-muted-foreground uppercase tracking-wide mb-4">
              Why It Matters
            </h3>
            <ul className="space-y-3">
              {whyItems.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-2 text-sm text-foreground"
                >
                  <CheckCircle2 className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Trust strip */}
        <div className="mt-10 text-center">
          <p className="inline-flex items-center gap-2 rounded-full border border-primary/15 bg-primary/5 px-4 py-2 text-xs font-medium text-primary">
            <CheckCircle2 className="h-3.5 w-3.5" />
            Validated across all major lower-48 U.S. regions using regional
            native plant references and ecological matching.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EcosystemTrustSection;
